module.exports = __webpack_public_path__ + "img/productBgImg1.d9247ea2.png";